document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-warranty-video-media]').forEach(function (media) {
    var playBtn = media.querySelector('[data-warranty-video-play]');
    var videoPlayer = media.querySelector('[data-warranty-video-player]');

    if (!playBtn || !videoPlayer) return;

    function play() {
      media.classList.add('has-started', 'is-playing');
      playBtn.setAttribute('aria-label', 'Pause video');

      if (videoPlayer.ended) {
        videoPlayer.currentTime = 0;
      }

      videoPlayer.play();
    }

    function pause() {
      media.classList.remove('is-playing');
      playBtn.setAttribute('aria-label', 'Play video');
      videoPlayer.pause();
    }

    function toggle() {
      if (media.classList.contains('is-playing')) {
        pause();
      } else {
        play();
      }
    }

    playBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      toggle();
    });

    media.addEventListener('click', function () {
      if (!media.classList.contains('has-started')) return;

      if (media.classList.contains('is-playing')) {
        pause();
      } else {
        play();
      }
    });

    videoPlayer.addEventListener('ended', function () {
      media.classList.remove('is-playing');
      playBtn.setAttribute('aria-label', 'Play video');
    });
  });
});
